import { useCallback, useState } from 'react';
import { FILTERS } from './useSearchFilters';

export const itemsPerPageOptions = [100, 50, 25];

export function usePagination(setFilter, totalItems) {
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);

	const onPageChange = useCallback(
		(page) => {
			setCurrentPage(page);
			setFilter(FILTERS.OFFSET, (page - 1) * itemsPerPage);
		},
		[setFilter, itemsPerPage],
	);

	const onItemsPerPageChange = useCallback(
		(number) => {
			// If number is NaN, you're choosing All.
			// It's kinda hacky, but they don't provide a way to do it easily, and it will work well enough.
			const value = isNaN(number) ? totalItems || 100 : number;
			const firstItemShown = value * (currentPage - 1) + 1;
			const newPage = Math.floor(firstItemShown / value) + 1;

			// FIXME: There's a bug in the Table/Pagination component that causes you to sometimes
			// go to the page before the one you should be on, when changing the items per page to an amount lower than the current amount.
			setItemsPerPage(value);
			setFilter(FILTERS.LIMIT, value);
			setCurrentPage(newPage);
		},
		[currentPage, setFilter, totalItems],
	);

	return {
		currentPage,
		totalItems,
		itemsPerPage,
		itemsPerPageOptions,
		onPageChange,
		onItemsPerPageChange,
	};
}
